import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { CDBModal } from "cdbreact";
import swal from "sweetalert";
import Swal from 'sweetalert2';
import { LargeCard } from "../Cards/LargeCard";
import { ModalSkus } from "../Modals/ModalSkus";
import { ModalBulkLoad } from "../Modals/ModalBulkLoad";
import { get, post, put, deleteRequestV2 } from "../../api/usersModule/httpClient";
import { useDebounce } from "../../hooks/useDebounce";

const defaultFormData = {
  CodeSap: "",
  SkuDescription: "",
  Nit: "",
  article_type: "",
  category: "",
  Rop: "",
  SkuMin: 0,
  SkuMax: 0,
  Inventory: "",
  PercentInventory: 0,
  SendQuantity: 0,
  unit_type: "",
  show_status: null, // Puede venir nulo/vacío desde el backend
  CreateDate: "",
  User: "",
};

export const CrudSkus = ({ userName, permissions, project, nit }) => {
  const baseHeaders = [
    "Código SAP",
    "Descripción",
    "Código Proveedor",
    "Proveedor",
    "Tipo de Artículo",
    "Categoría",
    "Rop",
    "Cant. Inventario",
    "Unid. de medida",
    "% Inventario",
    "Cant. a enviar",
    "MTS/MTO",
    "/skus",
  ];

  const getUsersHeaders = (project, nit) => {
    const headers = [...baseHeaders];
    if (2 === '1' || 2 === '1') {
      headers.splice(7, 0, "Cant. mínima", "Cant. máxima");
    }
    return headers;
  };

  const usersHeaders = getUsersHeaders(project, nit);
  
  const [data, setData] = useState([]);
  const [state, setState] = useState({ modal6: false, modal7: false });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [refresh, setRefresh] = useState(false);
  const debouncedSearch = useDebounce(search, 500);
  const [pressedButton, setPressedButton] = useState('');
  const [action, setAction] = useState('');
  const [totalItems, setTotalItems] = useState(0);
  const navigate = useNavigate();
  const [providers, setProviders] = useState([]);
  const [articleTypes, setArticleTypes] = useState([]);
  const [categories, setCategories] = useState([]);
  const [page, setPage] = useState(1);
  const [initialRender, setInitialRender] = useState(true);
  const [changePage, setChangePage] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [filterArticles, setFilterArticles] = useState([]); // Cambio: array para múltiples selecciones
  const [filterCategories, setFilterCategories] = useState([]); // Cambio: array para múltiples selecciones
  const [searchArticle, setSearchArticle] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [showArticleDropdown, setShowArticleDropdown] = useState(false);
  const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);

  // Filtros por columna estilo Excel. Cada clave corresponde a una columna del backend
  // y guarda los valores exactos seleccionados en el desplegable de esa columna.
  const [columnFilters, setColumnFilters] = useState({});

  // Búsquedas de texto por columna. Ej.: { CodeSap: "B0" }
  // Se envían separadas de los checks para aplicar CONTIENE en el backend.
  const [columnSearchFilters, setColumnSearchFilters] = useState({});

  const [formData, setFormData] = useState({
    ...defaultFormData,
    user: userName,
  });

  // Funciones para filtrar las listas
  const filteredArticleTypes = articleTypes.filter(type =>
    type.name.toLowerCase().includes(searchArticle.toLowerCase())
  );

  const filteredCategories = categories.filter(category =>
    category.name.toLowerCase().includes(searchCategory.toLowerCase())
  );

  const handleArticleSelect = (articleName) => {
    if (!filterArticles.includes(articleName)) {
      setFilterArticles([...filterArticles, articleName]);
    }
    setSearchArticle("");
    setShowArticleDropdown(false);
  };

  const handleCategorySelect = (categoryName) => {
    if (!filterCategories.includes(categoryName)) {
      setFilterCategories([...filterCategories, categoryName]);
    }
    setSearchCategory("");
    setShowCategoryDropdown(false);
  };

  const removeArticleFilter = (articleToRemove) => {
    setFilterArticles(filterArticles.filter(article => article !== articleToRemove));
  };

  const removeCategoryFilter = (categoryToRemove) => {
    setFilterCategories(filterCategories.filter(category => category !== categoryToRemove));
  };

  const clearAllArticleFilters = () => {
    setFilterArticles([]);
    setSearchArticle("");
    setShowArticleDropdown(false);
  };

  const clearAllCategoryFilters = () => {
    setFilterCategories([]);
    setSearchCategory("");
    setShowCategoryDropdown(false);
  };

  const getData = async (search, statusPage) => {
    try {
      setLoading(true);
      
      // Construir la URL con filtros opcionales
      let url = `/skus?page=${statusPage || page}&search=${search}&Nit=${nit || project}&limit=${itemsPerPage}&status=${true}`;
      
      // Enviar múltiples tipos de artículos como parámetros separados o como array JSON
      if (filterArticles && filterArticles.length > 0) {
        url += `&filterArticles=${encodeURIComponent(JSON.stringify(filterArticles))}`;
      }
      
      // Enviar múltiples categorías
      if (filterCategories && filterCategories.length > 0) {
        url += `&filterCategories=${encodeURIComponent(JSON.stringify(filterCategories))}`;
      }

      if (columnFilters && Object.keys(columnFilters).length > 0) {
        url += `&columnFilters=${encodeURIComponent(JSON.stringify(columnFilters))}`;
      }

      if (columnSearchFilters && Object.keys(columnSearchFilters).length > 0) {
        url += `&columnSearchFilters=${encodeURIComponent(JSON.stringify(columnSearchFilters))}`;
      }
      
      const response = await get(url);
  
      setTotalItems(response.answer ? response.pagination.totalItems : 0);
      setData(response.items);
    } catch (error) {
      swal('Error', 'Ocurrio un error al obtener los datos ', 'error');
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const getColumnFilterOptions = async (columnKey) => {
    try {
      let url = `/skus?page=1&limit=20&Nit=${nit || project}&status=${true}&filterOptionsColumn=${encodeURIComponent(columnKey)}`;

      if (debouncedSearch) {
        url += `&search=${encodeURIComponent(debouncedSearch)}`;
      }

      if (columnFilters && Object.keys(columnFilters).length > 0) {
        url += `&columnFilters=${encodeURIComponent(JSON.stringify(columnFilters))}`;
      }

      if (columnSearchFilters && Object.keys(columnSearchFilters).length > 0) {
        url += `&columnSearchFilters=${encodeURIComponent(JSON.stringify(columnSearchFilters))}`;
      }

      const response = await get(url);
      return response && Array.isArray(response.options) ? response.options : [];
    } catch (error) {
      console.error('Error obteniendo valores del filtro de columna:', error);
      return [];
    }
  };

  const handleNavigateToReception = (codeSap, nit, project) => {
    let stateParams = ''
    if(nit != '' && nit !=null && nit != undefined){
      stateParams = { codeSap, nit };
      navigate(`/reception`, { state: stateParams });
    }else if(project != '' && project !=null && project != undefined){
      stateParams = { codeSap, project };
      navigate(`/reception`, { state: stateParams });
    }
  };

  const getSku = async (sap, isEdit = false) => {
    Swal.fire({
      title: 'Cargando SKU',
      text: 'Por favor, espere...',
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });

    try {
      let url = `/skus?CodeSap=${sap.split("/*-/")[0]}&Nit=${sap.split("/*-/")[1]}`;
      if (isEdit) {
        url += "&editSku=true";
      }
      const response = await get(url);
      Swal.close();
      
      if (response && response.items && response.items.length > 0) {
        setFormData(response.items[0]);
        toggle(6)();
      } else {
        console.error('Error al obtener SKU: No se encontraron elementos en la respuesta');
        swal('Error', 'No se encontraron datos del SKU. Por favor, inténtalo de nuevo más tarde.', 'error');
        setFormData(response.items[0]);
      }
    } catch (error) {
      Swal.close();
      console.error('Error al obtener SKU:', error);
      swal('Error', 'Error al obtener datos del SKU. Por favor, inténtalo de nuevo más tarde.', 'error');
    }
  };  

  const getReportSku = async (nitReport) => {
    try {
      const { value: generateReport } = await Swal.fire({
        title: '¿Desea generar el reporte?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#146284',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Sí, generar',
        cancelButtonText: 'Cancelar'
      });
  
      if (generateReport) {
        Swal.fire({
          title: 'Generando Reporte',
          text: 'Por favor, espere...',
          icon: 'info',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
  
        const response = await get(`/skus?Nit=${nitReport}&reportSkus=${true}&sort_by=CreateDate`);
  
        if (response && response.answer) {
          Swal.close();
          if (response.url) {
            window.open(response.url, '_blank');
          } else {
            throw new Error('No se encontró la URL del reporte en la respuesta');
          }
        } else {
          throw new Error('Respuesta inesperada al generar el reporte');
        }
      }
    } catch (error) {
      console.error('Error generating report:', error);
      swal('Error', 'Error al generar el reporte. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
  };    

  const getProviders = async () => {
    try {
      const response = await get(`/projects?Nit=${nit || project}&list=${true}`);
      if (response && response.items) {
        setProviders(response.items);
      } else {
        console.error('Error fetching providers: No items found in response');
        setProviders([]);
      }
    } catch (error) {
      console.error('Error fetching providers:', error);
      setProviders([]);
      swal('Error', 'Error al obtener los proveedores. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
  };

  const getArticleTypes = async () => {
    try {
      const response = await get('/article-types?list=true');
      if (response && response.data) {
        setArticleTypes(response.data);
      } else {
        console.error('Error fetching article types: No data found in response');
        setArticleTypes([]);
      }
    } catch (error) {
      console.error('Error fetching article types:', error);
      setArticleTypes([]);
      swal('Error', 'Error al obtener los tipos de artículo. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
  };

  const getCategories = async () => {
    try {
      const response = await get('/categories?list=true');
      if (response && response.data) {
        setCategories(response.data);
      } else {
        console.error('Error fetching categories: No data found in response');
        setCategories([]);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
      setCategories([]);
      swal('Error', 'Error al obtener las categorías. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
  };  

  const closeModal = () => {
    setState({ ...state, modal6: false });
  };

  const closeModal7 = () => {
    setState({ ...state, modal7: false });
  };

  const toggle = (nr) => () => {
    const modalNumber = "modal" + nr;
    setState({ ...state, [modalNumber]: !state[modalNumber] });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const convertDataToArray = () => {
    try {
      if (!data || data.length === 0) {
        return [];
      }
  
      return data.map((item) => {
        const baseArray = [
          (item.CodeSap || "").toUpperCase(),
          (item.SkuDescription || "").toUpperCase(),
          item.Nit || "",
          item.ProjectName || "",
          (item.article_type || "").toUpperCase(),
          (item.category || "").toUpperCase(),
          parseFloat(item.Rop).toFixed(2) || "0.00",
          parseFloat(item.Inventory).toFixed(2) || "0.00",
          item.unit_type.toUpperCase() || "",
          `${parseFloat(item.PercentInventory).toFixed(2) || "0.00"}%`,
          parseFloat(item.SendQuantity).toFixed(2) || "0.00",
          item.show_status || "—",
        ];        
  
        if (2 === "1" || 2 === "1") {
          baseArray.splice(7, 0, parseFloat(item.SkuMin) || 0, parseFloat(item.SkuMax) || 0);
        }
  
        return baseArray;
      });
    } catch (error) {
      console.error('Error converting data to array:', error);
      return [];
    }
  };    

  const handleSubmit = () => {
    const requiredFields = {
      'CodeSap': 'Código SAP',
      'Nit': 'Código Proveedor',
      'SkuDescription': 'Descripción',
      'article_type': 'Tipo de Artículo',
      'category': 'Categoría',
      'unit_type': 'Unidad de medida',
      'Rop': 'ROP',
      'Inventory': 'Inventario'
    };
  
    const missingFields = Object.keys(requiredFields).filter(field => !formData[field]);
  
    if (missingFields.length > 0) {
      const missingFieldNames = missingFields.map(field => requiredFields[field]);
      const errorMessage = `Por favor, complete los siguientes campos obligatorios: ${missingFieldNames.join(', ')}`;
      swal('Error', errorMessage, 'error');
      setLoading(false);
      return false;
    }
  
    return true;
  };  

  const saveData = async () => {
    Swal.fire({
      title: `${action === "create" ? 'Creando' : 'Actualizando'} SKU`,
      text: 'Por favor, espere...',
      icon: 'info',
      allowOutsideClick: false,
      showCancelButton: false,
      showConfirmButton: false,
      willOpen: () => {
        Swal.showLoading();
      },
    });
  
    const { CodeSap, SkuDescription, Nit, article_type, category, Rop, Inventory, unit_type } = formData;
    const User = userName || 'Admin';
  
    try {
      const response = await (action === "create" ? post : put)("/skus", {
        CodeSap: CodeSap.toUpperCase(),
        SkuDescription: SkuDescription.toUpperCase(),
        Nit: Nit || project,
        article_type: article_type || "",
        category: category || "",
        Rop: parseFloat(Rop), // Asegurarse de que Rop se envíe como número con decimales
        Inventory: parseFloat(Inventory), // Asegurarse de que Inventory se envíe como número con decimales
        unit_type: unit_type.toUpperCase(),
        show_status: (formData.show_status === 'Sin proporcionar' ? null : formData.show_status ?? null),
        User: User.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')
      });
  
      if (!response.answer) {
        swal('Error', `No se pudo ${action === "create" ? 'crear' : 'actualizar'} el Sku. Por favor, revise la información (Puede deberse a que ya se tiene un ID ya registrado).`, 'error');
      } else if (response.answer) {
        toggle(6)();
        swal(`Sku ${action === "create" ? 'creada' : 'actualizada'}`, `El Sku se ${action === "create" ? 'creó' : 'actualizó'} correctamente.`, 'success');
      }
      getData('', 1);
      Swal.close();
    } catch (error) {
      Swal.close();
      console.error(`Error al ${action === "create" ? 'crear' : 'actualizar'} el Sku:`, error);
    }
  };  

  const deleteSku = async () => {
    try {
      const { CodeSap, SkuDescription, Nit, Rop, Inventory, unit_type } = formData;
      const User = userName || 'Admin';
  
      const body = JSON.stringify({
        CodeSap: CodeSap,
        Nit: Nit,
        Rop: parseFloat(Rop),
        Inventory: parseFloat(Inventory),
        User: User
      });
  
      const confirmDelete = await Swal.fire({
        title: 'Confirmar Eliminación del SKU',
        text: 'Esta acción eliminará de manera permanente el SKU seleccionado, así como cualquier dato relacionado. ¿Está seguro de que desea proceder?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#146284',
        cancelButtonColor: '#EF4444',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar',
      });
  
      if (confirmDelete.isConfirmed) {
        Swal.fire({
          title: 'Eliminando SKU',
          text: 'Por favor, espere...',
          icon: 'info',
          allowOutsideClick: false,
          showCancelButton: false,
          showConfirmButton: false,
          willOpen: () => {
            Swal.showLoading();
          },
        });
  
        await deleteRequestV2('skus', body, true);
  
        Swal.close();
  
        toggle(6)();
        getData('', 1);
      }
    } catch (error) {
      console.error('Error deleting SKU:', error);
      swal('Error', 'Error al eliminar el SKU. Por favor, inténtelo de nuevo más tarde.', 'error');
    }
  };  

  useEffect(() => {
    if (initialRender) {
      setInitialRender(false);
      // Cargar los datos de filtros al inicio
      getArticleTypes();
      getCategories();
      return;
    }

    if (!changePage) {
      getData(debouncedSearch, page);
    }else {
      setChangePage(false)
    }

  }, [page, initialRender]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1)
  }, [debouncedSearch]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1)
  }, [itemsPerPage]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1)
  }, [filterArticles, filterCategories]);

  useEffect(() => {
    getData(debouncedSearch, 1);
    setChangePage(true);
    setPage(1);
  }, [columnFilters, columnSearchFilters]);

  // Cerrar dropdowns al hacer clic fuera
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('[data-dropdown="article"]')) {
        setShowArticleDropdown(false);
      }
      if (!event.target.closest('[data-dropdown="category"]')) {
        setShowCategoryDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (refresh) {
      getData('', page);
      setRefresh(false);
    }
  }, [refresh]);

  useEffect(() => {
    switch (pressedButton.split(",")[0]) {
      case "create":
        if (permissions["Crear"]) {
          getProviders();
          getArticleTypes();
          getCategories();
          setAction("create");
          setFormData(defaultFormData);
          toggle(6)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear Skus",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "edit":
        if (permissions["Editar"]) {
          getProviders();
          getArticleTypes();
          getCategories();
          setAction("edit");
          getSku(pressedButton.split(',')[1], true);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para editar Skus",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "delete":
        if (permissions["Eliminar"]) {
          deleteSku(pressedButton.split(',')[1]);
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para borrar Skus",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "bulkLoad":
        if (permissions["Crear"]) {
          setAction("create");
          setFormData(defaultFormData);
          toggle(7)();
        } else {
          swal({
            title: "Error",
            text: "No tiene permisos para crear Skus",
            icon: "error",
            buttons: ["", "Aceptar"],
          });
        }
        break;
      case "refresh":
        getData('', page);
        break;
      case "monthlyReport":
        getReportSku(nit || project);
        break;
      case 'indicators':
        handleNavigateToReception(pressedButton.split(',')[1], nit, project);
        break;
      case "closeModal":
        if (state.modal6) {
          toggle(6)();
        }
        if (state.modal7) {
          closeModal7();
        }
        break;
      case "submitModal":
        const success = handleSubmit();
        if (success) {
          saveData();
          toggle(6)();
        }
        break;
      default:
        break;
    }
    setPressedButton("");
  }, [pressedButton]);

  const name = "Skus para el proveedor con código: " + (nit || project);

  // Componente de filtros personalizados para SKUs
  const customFilters = (
    <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
      {/* Filtro de Tipo de Artículo */}
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '220px', position: 'relative' }} data-dropdown="article">
        <label htmlFor="filterArticle" style={{ marginBottom: '6px', fontWeight: 'bold', fontSize: '13px', color: '#333' }}>
          Tipos de Artículo:
        </label>
        
        {/* Mostrar artículos seleccionados */}
        {filterArticles.length > 0 && (
          <div style={{ marginBottom: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {filterArticles.map((article, index) => (
              <span
                key={index}
                style={{
                  backgroundColor: '#e3f2fd',
                  color: '#1976d2',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                {article}
                <button
                  onClick={() => removeArticleFilter(article)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#1976d2',
                    cursor: 'pointer',
                    fontSize: '12px',
                    padding: '0',
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
        
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            id="filterArticle"
            value={searchArticle}
            onChange={(e) => {
              setSearchArticle(e.target.value);
              setShowArticleDropdown(true);
            }}
            onFocus={() => setShowArticleDropdown(true)}
            placeholder="Buscar tipos..."
            style={{
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '13px',
              width: '100%',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
          />
          {filterArticles.length > 0 && (
            <button
              onClick={clearAllArticleFilters}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#999',
                padding: '2px',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ×
            </button>
          )}
          {showArticleDropdown && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderTop: 'none',
              borderRadius: '0 0 4px 4px',
              maxHeight: '200px',
              overflowY: 'auto',
              zIndex: 1000,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <div
                onClick={clearAllArticleFilters}
                style={{
                  padding: '6px 10px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  backgroundColor: '#f8f9fa',
                  fontStyle: 'italic',
                  fontSize: '12px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              >
                Limpiar filtros
              </div>
              {filteredArticleTypes
                .filter(type => !filterArticles.includes(type.name))
                .map((type, index) => (
                <div
                  key={index}
                  onClick={() => handleArticleSelect(type.name)}
                  style={{
                    padding: '6px 10px',
                    cursor: 'pointer',
                    borderBottom: index < filteredArticleTypes.length - 1 ? '1px solid #eee' : 'none',
                    fontSize: '12px'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                >
                  {type.name}
                </div>
              ))}
              {filteredArticleTypes.filter(type => !filterArticles.includes(type.name)).length === 0 && searchArticle && (
                <div style={{ padding: '6px 10px', color: '#666', fontStyle: 'italic', fontSize: '12px' }}>
                  No se encontraron tipos de artículo disponibles
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      
      {/* Filtro de Categoría */}
      <div style={{ display: 'flex', flexDirection: 'column', minWidth: '220px', position: 'relative' }} data-dropdown="category">
        <label htmlFor="filterCategory" style={{ marginBottom: '6px', fontWeight: 'bold', fontSize: '13px', color: '#333' }}>
          Categorías:
        </label>
        
        {/* Mostrar categorías seleccionadas */}
        {filterCategories.length > 0 && (
          <div style={{ marginBottom: '8px', display: 'flex', flexWrap: 'wrap', gap: '4px' }}>
            {filterCategories.map((category, index) => (
              <span
                key={index}
                style={{
                  backgroundColor: '#e8f5e8',
                  color: '#2e7d32',
                  padding: '2px 8px',
                  borderRadius: '12px',
                  fontSize: '11px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px'
                }}
              >
                {category}
                <button
                  onClick={() => removeCategoryFilter(category)}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#2e7d32',
                    cursor: 'pointer',
                    fontSize: '12px',
                    padding: '0',
                    width: '14px',
                    height: '14px',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  }}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        )}
        
        <div style={{ position: 'relative' }}>
          <input
            type="text"
            id="filterCategory"
            value={searchCategory}
            onChange={(e) => {
              setSearchCategory(e.target.value);
              setShowCategoryDropdown(true);
            }}
            onFocus={() => setShowCategoryDropdown(true)}
            placeholder="Buscar categorías..."
            style={{
              padding: '8px 12px',
              border: '1px solid #ddd',
              borderRadius: '4px',
              fontSize: '13px',
              width: '100%',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
            }}
          />
          {filterCategories.length > 0 && (
            <button
              onClick={clearAllCategoryFilters}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                fontSize: '16px',
                color: '#999',
                padding: '2px',
                borderRadius: '50%',
                width: '20px',
                height: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              ×
            </button>
          )}
          {showCategoryDropdown && (
            <div style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderTop: 'none',
              borderRadius: '0 0 4px 4px',
              maxHeight: '200px',
              overflowY: 'auto',
              zIndex: 1000,
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <div
                onClick={clearAllCategoryFilters}
                style={{
                  padding: '6px 10px',
                  cursor: 'pointer',
                  borderBottom: '1px solid #eee',
                  backgroundColor: '#f8f9fa',
                  fontStyle: 'italic',
                  fontSize: '12px'
                }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#e9ecef'}
                onMouseLeave={(e) => e.target.style.backgroundColor = '#f8f9fa'}
              >
                Limpiar filtros
              </div>
              {filteredCategories
                .filter(category => !filterCategories.includes(category.name))
                .map((category, index) => (
                <div
                  key={index}
                  onClick={() => handleCategorySelect(category.name)}
                  style={{
                    padding: '6px 10px',
                    cursor: 'pointer',
                    borderBottom: index < filteredCategories.length - 1 ? '1px solid #eee' : 'none',
                    fontSize: '12px'
                  }}
                  onMouseEnter={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                  onMouseLeave={(e) => e.target.style.backgroundColor = 'white'}
                >
                  {category.name}
                </div>
              ))}
              {filteredCategories.filter(category => !filterCategories.includes(category.name)).length === 0 && searchCategory && (
                <div style={{ padding: '6px 10px', color: '#666', fontStyle: 'italic', fontSize: '12px' }}>
                  No se encontraron categorías disponibles
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div>
        
        <LargeCard
          name={name}
          headers={usersHeaders}
          loading={loading}
          data={convertDataToArray()}
          totalItems={totalItems}
          customTable={false}
          setPage={setPage}
          page={page}
          setChangePage={setChangePage}
          setPressedButton={setPressedButton}
          setSearch={setSearch}
          bulkLoad={true}
          cState={true}
          colorPorcentage={true}
          itemsPerPage={itemsPerPage}
          setItemsPerPage={setItemsPerPage}
          excelColumnFilters={columnFilters}
          setExcelColumnFilters={setColumnFilters}
          excelColumnSearchFilters={columnSearchFilters}
          setExcelColumnSearchFilters={setColumnSearchFilters}
          getExcelFilterOptions={getColumnFilterOptions}
        />
      </div>

      <CDBModal isOpen={state.modal6} toggle={toggle(6)}>
        <ModalSkus
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          closeModal={closeModal}
          handleChange={handleChange}
          providers={providers}
          articleTypes={articleTypes}
          categories={categories}
        />
      </CDBModal>
      <CDBModal isOpen={state.modal7} keyboard={false} toggle={toggle(8)}>
        <ModalBulkLoad
          action={action}
          setPressedButton={setPressedButton}
          formData={formData}
          handleChange={handleChange}
          project={project}
          userName={userName}
          setRefresh={setRefresh}
        />
      </CDBModal>
    </>
  );
};